import React from "react";
import { useLocation } from "react-router-dom";
import Header from "./shared/Header";
import Footer from "./shared/Footer";
import HCMDashboardSidebar from "./shared/HCMDashboardSidebar";
import ApplicantDashboardSidebar from "./shared/ApplicantDashboardSidebar";
import EmployeeDashboardSidebar from "./shared/EmployeeDashboardSidebar";

const Layout = ({ children }) => {
  const location = useLocation();

  // Show DashboardSidebar only for dashboard-related routes
  const isHCMDashboardPage = location.pathname.startsWith("/dashboard");
  const isApplicantDashboardPage = location.pathname.startsWith("/applicant");
  const isEmployeePage = location.pathname.startsWith("/employee") || location.pathname === "/employee-profile" || location.pathname === "/employee-dashboard";

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
      {/* Global Header */}
      <Header />

      <div style={{ display: "flex", flex: 1, marginTop: "60px", backgroundColor: "#f9f9f9" }}> {/* Adjust margin to account for header height */}
        {/* Sidebar for dashboard pages */}
        {isHCMDashboardPage && <HCMDashboardSidebar />}
        
        {/* Sidebar for applicant dashboard pages */}
        {isApplicantDashboardPage && <ApplicantDashboardSidebar />}
        
        {/* Sidebar for employee pages */}
        {isEmployeePage && <EmployeeDashboardSidebar />}

        {/* Main Content */}
        <main
          style={{
            flex: 1,
            padding: "20px",
            overflowY: "auto", // Enable scrolling for main content
            backgroundColor: "#f9f9f9",
            marginLeft: (isHCMDashboardPage || isApplicantDashboardPage || isEmployeePage) ? "60px" : "0", // Default margin for collapsed sidebar
          }}
        >
          {children}
        </main>
      </div>

      {/* Global Footer */}
      <Footer />
    </div>
  );
}

export default Layout;
